import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import * as currentUserStoreModule from '@/store/global/currentUser';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class AddOrRemoveTaskToTrackingFilter extends Action<StorymapState> {
    public static ACTION_TYPE = 'AddOrRemoveTaskToTrackingFilter';

    public constructor(public taskId: string) {
        super(AddOrRemoveTaskToTrackingFilter.ACTION_TYPE);
    }
}

const middleware = async (): Promise<boolean> => {
    const store = currentUserStoreModule.useCurrentUserModule();

    await store.dispatch(new currentUserStoreModule.DismissQuickTip('RELEASE_VIEW_FILTER_DISMISS_KEY'));
    return true;
};

const reducer = (state: StorymapState, action: AddOrRemoveTaskToTrackingFilter): void => {
    const taskId = state.trackingViewState.filterTaskIds.find((x) => x === action.taskId);

    const task = state.tasks.find((x) => x.id == action.taskId);
    const siblingTasks = state.tasks.filter((x) => x.activityId == task.activityId);

    if (taskId == null) {
        state.trackingViewState.filterTaskIds.push(action.taskId);

        if (!state.trackingViewState.filterActivityIds.includes(task.activityId)) {
            state.trackingViewState.filterActivityIds.push(task.activityId);
        }
    } else {
        state.trackingViewState.filterTaskIds = state.trackingViewState.filterTaskIds.filter((x) => x !== action.taskId);

        // Kiszedjük a parent activity-t is a filterből , ha ez volt az utolsó filterezett task...???
        const shouldRemoveActivity = siblingTasks.every((x) => !state.trackingViewState.filterTaskIds.includes(x.id));

        if (shouldRemoveActivity) {
            state.trackingViewState.filterActivityIds = state.trackingViewState.filterActivityIds.filter((x) => x !== task.activityId);
        }
    }
};

//@ts-ignore
registerMiddleware(AddOrRemoveTaskToTrackingFilter.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(AddOrRemoveTaskToTrackingFilter.ACTION_TYPE, reducer);
